'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestMiddleware = undefined;
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _constants = require('@marmalade/constants');
var _constants2 = _interopRequireDefault(_constants);
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');
var _get2 = _interopRequireDefault(_get);
var _constants3 = require('../constants');
var _selectors = require('../selectors');
var _utils = require('./utils');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
var getProductFromClientId = function getProductFromClientId(clientId) {
  var clientIds = _constants2.default.clientId;
  var products = Object.keys(clientIds);
  return products.find(function (product) {
    return clientIds[product] === clientId;
  });
};
var requestRefreshToken = function () {
  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(store, next, action) {
    var state, clientId, product, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = store.getState();
            clientId = (0, _selectors.getClientId)(state) || _constants2.default.clientId[action.product];
            product = getProductFromClientId(clientId) || action.product;
            _context.prev = 3;
            _context.next = 6;
            return _axios2.default.post(_constants3.endpoints.auth(product), {
              grant_type: 'refresh_token',
              client_id: clientId,
              refresh_token: (0, _selectors.getRefreshToken)(state)
            });
          case 6:
            response = _context.sent;
            next({
              type: _constants3.actionTypes.REFRESH_TOKEN,
              payload: response,
              meta: {
                clientId: clientId
              }
            });
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](3);
            _context.t0.authError = true;
            throw _context.t0;
          case 14:
            return _context.abrupt('return', (0, _selectors.getAccessToken)(store.getState()));
          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[3, 10]]);
  }));
  return function requestRefreshToken(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var requestRefreshTokenMemo = (0, _utils.memoizeWhilePending)(requestRefreshToken);

// Although nothing in this function is async it marked as async so it can be
// called the same way every time even when the token is in the redux store.
// Always returns a Promise.
var getOrRequestAccessToken = function () {
  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref2) {
    var action = _ref2.action,
      store = _ref2.store,
      next = _ref2.next,
      _ref2$forceRefresh = _ref2.forceRefresh,
      forceRefresh = _ref2$forceRefresh === undefined ? false : _ref2$forceRefresh;
    var state, currentToken, error;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = store.getState();
            currentToken = (0, _selectors.getAccessToken)(state);

            // To be logged in there must be a auth token even if it is expired/not valid.

            if (currentToken) {
              _context2.next = 6;
              break;
            }
            error = new Error('No auth token in redux store');
            error.authError = true;
            throw error;
          case 6:
            if (!((0, _selectors.hasValidToken)(state) && !forceRefresh)) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt('return', currentToken);
          case 8:
            return _context2.abrupt('return', requestRefreshTokenMemo(store, next, action));
          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));
  return function getOrRequestAccessToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var methodsWithoutBody = ['get', 'head', 'delete'];
var createAxiosRequestConfig = function createAxiosRequestConfig(_ref4) {
  var _Object$assign;
  var token = _ref4.token,
    request = _ref4.request;
  var _request$method = request.method,
    method = _request$method === undefined ? 'get' : _request$method,
    responseType = request.responseType,
    params = request.params,
    url = request.baseUrl,
    requestHeader = request.headers;
  var headers = Object.assign({
    Authorization: 'Bearer ' + token
  }, requestHeader);
  return Object.assign((_Object$assign = {
    method: method,
    url: url
  }, _defineProperty(_Object$assign, methodsWithoutBody.includes(method) ? 'params' : 'data', params), _defineProperty(_Object$assign, 'headers', headers), _Object$assign), responseType ? {
    responseType: responseType
  } : {});
};

/*
  isTokenExpiredResponse

  Checks the response a 401 and the payload is this shape
  {
      "status": "FAIL",
      "error": {
          "description": "The access token provided has expired.",
          "code": 104
      }
  }
*/
var isTokenExpiredResponse = function isTokenExpiredResponse(response) {
  return (0, _get2.default)(response, 'status') === 401 && (0, _get2.default)(response, 'data.error.code') === 104;
};
var authRequest = function () {
  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(store, next, action) {
    var request, token, response, _token;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            request = action.request;
            _context3.next = 3;
            return getOrRequestAccessToken({
              action: action,
              store: store,
              next: next
            });
          case 3:
            token = _context3.sent;
            if (!(typeof request === 'function')) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt('return', request(token));
          case 6:
            response = void 0;
            _context3.prev = 7;
            _context3.next = 10;
            return (0, _axios2.default)(createAxiosRequestConfig({
              token: token,
              request: request
            }));
          case 10:
            response = _context3.sent;
            _context3.next = 23;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3['catch'](7);
            if (isTokenExpiredResponse(_context3.t0.response)) {
              _context3.next = 17;
              break;
            }
            throw _context3.t0;
          case 17:
            _context3.next = 19;
            return getOrRequestAccessToken({
              action: action,
              store: store,
              next: next,
              forceRefresh: true
            });
          case 19:
            _token = _context3.sent;
            _context3.next = 22;
            return (0, _axios2.default)(createAxiosRequestConfig({
              token: _token,
              request: request
            }));
          case 22:
            response = _context3.sent;
          case 23:
            return _context3.abrupt('return', typeof request.then === 'function' ? request.then(response) : response);
          case 24:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[7, 13]]);
  }));
  return function authRequest(_x5, _x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();
var requestMiddleware = exports.requestMiddleware = function requestMiddleware(store, next, action) {
  return next({
    type: action.type,
    meta: Object.assign({}, action.meta, {
      authRequest: true
    }, typeof action.request.onError === 'function' ? {
      onError: action.request.onError
    } : {}),
    // payload is a promise that is handled by redux-promise-middleware
    payload: authRequest(store, next, action)
  });
};